import o from "./ghl-ui.es1525.js";
import t from "./ghl-ui.es1516.js";
import m from "./ghl-ui.es1481.js";
function u(r) {
  if (m(1, arguments), !o(r) && typeof r != "number")
    return !1;
  var e = t(r);
  return !isNaN(Number(e));
}
export {
  u as default
};
